import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id C497D005-A9A3-4B1A-B440-CE574E81AF2F
 * name pan-top-left
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pan-top-left.svg
 * tags
 */
export const PanTopLeftIcon = createSvgIcon(<><path d="M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M11,5.35L5.35,11L5,5L11,5.35Z" /></>, 'PanTopLeftIcon');
export default PanTopLeftIcon